import './landing-page-vt-logo.component.scss';

export default {
    template: require('./landing-page-vt-logo.component.html'),
    controller: function () {
        'ngInject';
    }
};
